import request from '@/utils/request'


function datacenterIndex() {    // 数据总览
    return request({
        url: '/datacenter/index',
        method: 'POST',
    })
}

function datacenterGetsourcetrend(data) {        // 信源趋势图
    return request({
        url: 'datacenter/getsourcetrend',
        method: 'POST',
        data
    })
}

function datacenterGetsourcerate(data) {    //信源占比图
    return request({
        url: 'datacenter/getsourcerate',
        method: 'POST',
        data
    })
}

function datacenterGetemotiontrend(data) {   // 情绪趋势图
    return request({
        url: 'datacenter/getemotiontrend',
        method: 'POST',
        data
    })
}

function datacenterGetemotionrate(data) {   // 情绪占比图
    return request({
        url: 'datacenter/getemotionrate',
        method: 'POST',
        data
    })
}

function datacenterGetheatedtopic(data) {   // 热议话题词云图
    return request({
        url: 'datacenter/getheatedtopic',
        method: 'POST',
        data
    })
}

function datacenterGetlatestnews(data) {   //最新数据
    return request({
        url: 'datacenter/getlatestnews',
        method: 'POST',
        data
    })
}



function datacenterGetsourcetop10(data) {   // 数据来源top10
    return request({
        url: 'datacenter/getsourcetop10',
        method: 'POST',
        data
    })
}

export {
    datacenterIndex,
    datacenterGetsourcetrend,
    datacenterGetsourcerate,
    datacenterGetemotiontrend,
    datacenterGetheatedtopic,
    datacenterGetlatestnews,
    datacenterGetsourcetop10,
    datacenterGetemotionrate
}
